export default "<h1 data-bind=\"i18n\">Page not found</h1>\n\n<p>\n  <a data-bind=\"tenantHref: '/', i18n\">Return to home page</a>\n</p>\n";